import { camelCase, find, update } from 'lodash';
import apollo from './client';

const BASE_ERROR_FIELD = 'base';

export default {
  async mutate(options = {}) {
    const mutationOpts = Object.assign({}, options);

    // Currently only a single mutation operation is supported for forms,
    // which should be generally OK!
    let mutationName = mutationOpts.mutationName;
    if (!mutationName) {
      const mutation = find(options.mutation.definitions,
                            definition => definition.operation === 'mutation');
      mutationName = camelCase(mutation.name.value);
    }
    delete mutationOpts.mutationName;

    // Perform the actual mutation.
    const { data } = await apollo.mutate(mutationOpts);

    // Transform validation errors in the response, if there are any.
    return this.transform(data[mutationName]);
  },

  transform(data) {
    const errors = this.formatErrors(data.errors);
    const isValid = Object.keys(errors).length === 0;
    return Object.assign({}, data, { errors, isValid });
  },

  // FIXME: Need to refactor this as some edge cases are unhandled, for example,
  // when getting mixed errors for a field and child fields.
  //
  // { field: 'color', message: 'must be present' },
  // { field: 'color.name', message: 'must be present' },
  // { field: 'color.code', message: 'is invalid' },
  formatErrors(errors) {
    const groupedErrors = {};
    if (errors && errors.length) {
      errors.forEach(({ field, message }) => {
        const fieldOrBase = field || BASE_ERROR_FIELD;
        update(groupedErrors, fieldOrBase, (fieldErrors) => {
          if (!fieldErrors) return [message];
          return fieldErrors.concat(message);
        });
      });
    }
    return groupedErrors;
  },
};



// WEBPACK FOOTER //
// ./api/validated-mutation.js